import { render, staticRenderFns } from "./Codetestdatabank.vue?vue&type=template&id=a95e933e&scoped=true"
import script from "./Codetestdatabank.vue?vue&type=script&lang=js"
export * from "./Codetestdatabank.vue?vue&type=script&lang=js"
import style0 from "./Codetestdatabank.vue?vue&type=style&index=0&id=a95e933e&prod&scoped=true&lang=css"
import style1 from "./Codetestdatabank.vue?vue&type=style&index=1&id=a95e933e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95e933e",
  null
  
)

export default component.exports